import { useMemo, useRef } from "react";
import { Autocomplete, useLoadScript } from "@react-google-maps/api";

const libraries = ["places"];

export default function LocationSearchInput({ 
  value, 
  onTyping, 
  onSelect, 
  placeholder = "Enter a city or address" 
}) {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries
  });
  
  const acRef = useRef(null);

  const options = useMemo(() => ({
    componentRestrictions: { country: "us" },
    fields: ["place_id", "name", "formatted_address", "geometry"],
    types: ["(regions)"]
  }), []);

  const handlePlaceChanged = () => {
    const place = acRef.current?.getPlace();
    if (!place || !place.place_id) return;

    const lat = place.geometry?.location?.lat();
    const lng = place.geometry?.location?.lng();
    const label = place.name
      ? `${place.name}, ${place.formatted_address || ""}`.replace(/, *$/, "")
      : place.formatted_address || "";
    
    onSelect({
      label,
      place_id: place.place_id,
      lat,
      lng
    });
  };

  if (!isLoaded) {
    return (
      <input
        type="text"
        value={value}
        onChange={(e) => onTyping(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded border px-3 py-2"
        aria-label="Location"
      />
    );
  }

  return (
    <Autocomplete
      onLoad={(ac) => (acRef.current = ac)}
      onPlaceChanged={handlePlaceChanged}
      options={options}
    >
      <input
        type="text"
        value={value}
        onChange={(e) => onTyping(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded border px-3 py-2"
        aria-label="Location"
      />
    </Autocomplete>
  );
}
